import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';

import { routes } from 'flow/types/routes';
import { reloadConferences } from 'flow/actions/pbx-actions';
import { UserConferenceKey } from 'flow/types/EntityKeys';
import Loading from 'flow/components/ui-components/Loading';
import MeetingMain from 'flow/components/meeting/shared/MeetingMain';

const conferenceReloadTimeMS = 15000;

const PbxConference = () => {
    const { entityKey: lobbyEntityId } = useParams<{
        entityKey: UserConferenceKey;
    }>();
    const dispatch = useAppDispatch();
    const history = useHistory();

    const conferences = useAppSelector((state) => state.pbx.get('conferences'));

    useEffect(() => {
        dispatch(reloadConferences());

        const reloader = setInterval(() => {
            dispatch(reloadConferences());
        }, conferenceReloadTimeMS);

        return () => {
            clearInterval(reloader);
        };
    }, [dispatch]);

    if (!conferences) {
        return <Loading />;
    }

    const handleClickBack = () => {
        history.push(routes['messages.meetings']);
    };

    return (
        <MeetingMain
            meetingLobbyKey={lobbyEntityId}
            onClickBack={handleClickBack}
            allowToggleNewMembers={true}
            isPersonalMeetingRoom={true}
        />
    );
};

export default PbxConference;
